import { collectionValidation } from "../Validation";
import { IViolation } from "../../classes/ExternalQuote";

const rules = {
    accDisSet: 'required'
};

export const allViolationsValidation = (violations: Array<IViolation>) => {
    return collectionValidation(violations, (v) => v.id, rules);
};